import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpAuthorizationHeader } from '../misc/httpauthorizationheader';
import { ToastActions } from '../state/toast/toast.actions';
import { BLService } from './bl.service';
import {
  OnboardCompanyWithAnnualClientCollaborationPackageBody,
  OnboardCompanyWithAnnualClientCollaborationPackageResponse,
  OnboardExistingClientBody,
  OnboardingExtraClientInfo,
  OnboardingResponse,
} from './onboarding.service.types';

@Injectable({ providedIn: 'root' })
export class OnboardingService extends BLService {
  private options = new HttpAuthorizationHeader('application/json');
  private RESOURCE_ENDPOINT = 'onboarding';
  private url = environment.serverUrlV2 + this.RESOURCE_ENDPOINT;

  constructor() {
    super();
    this.useTranslation('OnboardingService');
  }

  getOnboardingKey(
    clientId: number,
    body: OnboardExistingClientBody,
    loadRemoteVatIntervalInformation = false,
  ): Observable<string> {
    return this.http
      .post<OnboardingResponse>(
        `${this.url}/${clientId}?loadRemoteVatIntervalInformation=${loadRemoteVatIntervalInformation}`,
        body,
        this.options.getAuthorizationHeaderWithEmptyBody(),
      )
      .pipe(
        map((response: OnboardingResponse) => response.key),
        catchError((err: unknown) => {
          this.dispatchOnboardingError();
          return throwError(() => err);
        }),
        this.catchErrorAndShowMessage(),
      );
  }

  getOnboardingKeyForNonExistingClient(
    body: OnboardingExtraClientInfo,
    loadRemoteVatIntervalInformation = false,
  ): Observable<string> {
    return this.http
      .post<OnboardingResponse>(
        `${this.url}?loadRemoteVatIntervalInformation=${loadRemoteVatIntervalInformation}`,
        { client: body },
        this.options.getAuthorizationHeaderWithEmptyBody(),
      )
      .pipe(
        map((response: OnboardingResponse) => response.key),
        this.catchErrorAndShowMessage(),
      );
  }

  onboardCompanyWithAnnualClientCollaborationPackage(
    body: OnboardCompanyWithAnnualClientCollaborationPackageBody,
  ): Observable<OnboardCompanyWithAnnualClientCollaborationPackageResponse> {
    return this.http
      .post<OnboardCompanyWithAnnualClientCollaborationPackageResponse>(
        `${this.url}/company/with-annual-client`,
        body,
        this.options.getAuthorizationHeaderWithEmptyBody(),
      )
      .pipe(this.catchErrorAndShowMessage());
  }

  private dispatchOnboardingError(): void {
    this.store.dispatch(
      ToastActions.showErrorMessage({
        summary: this.translate('anErrorOccured'),
        detail: this.translate('failedToFetchClientInformation'),
      }),
    );
  }
}
